import { render, staticRenderFns } from "./FamilyLayout.vue?vue&type=template&id=f4c19c3c"
import script from "./FamilyLayout.vue?vue&type=script&lang=js"
export * from "./FamilyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports